import { Button } from "primereact/button";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type AddOrderItemButtonProps } from "./add-order-item-button.interface";
import { type AddOrderItemButton_AddOrderItemMutation } from "../../../../__generated__/AddOrderItemButton_AddOrderItemMutation.graphql";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

const ADD_ORDER_ITEM_MUTATION = graphql`
	mutation AddOrderItemButton_AddOrderItemMutation($input: AddOrderItemInput!) {
		Admin {
			ElearningV2 {
				addOrderItem(input: $input) {
					orderElement {
						...OrderElementForm_OrderElementFragment
					}
				}
			}
		}
	}
`;

export const AddOrderItemButton = ({ orderElementId }: AddOrderItemButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [addOrderItem, isAddingOrderItem] =
		useMutation<AddOrderItemButton_AddOrderItemMutation>(ADD_ORDER_ITEM_MUTATION);

	return (
		<Button
			label={t("educationalOffer.addSequenceElement")}
			type="button"
			disabled={isAddingOrderItem}
			onClick={() =>
				addOrderItem({
					variables: {
						input: {
							orderElementId,
							text: t("educationalOffer.newSequenceElement"),
						},
					},
					updater: setDraft,
				})
			}
		/>
	);
};
